import Api from "./Api.js";
import qs from "qs";

const resource = "/facilities";

export default {
  getFacilities(filters = []) {
    Object.keys(filters).forEach(
      (key) => filters[key] == null && delete filters[key]
    );
    return Api.get(`${resource}`, {
      params: filters,
      paramsSerializer: (filters) => {
        return qs.stringify(filters, {
          arrayFormat: "brackets",
          encode: false,
        });
      },
    });
  },
};
